export const Role = {
    Admin: 'Admin',
    User: 'User',
    LockerAdmin: 'LockerAdmin'
}